import { defineStore } from 'pinia';

export const useProjectDetailsViewStore = defineStore('projectDetailsView', {
	state: () => ({
		isReportsOpen: false,
		calendarTimestamp: 0,
		calendarUpdateCounter: 0,
		/**
		 * Keep HTML for the Quoted vs Actual table in the store in order to
		 * restore it after the reports toggle has been toggled.
		 */
		quotedVsActualHTML: undefined as string | undefined,
		projectTabsTaskListFilters: {},
		projectTabsTaskBoardFilters: {},
		projectTabsEventListFilters: {},
	}),
});
